<template>
  <div>
    <page-header :title="boardTitle" :description="getBoardDesc">
    </page-header>
    <div class="page-body pt-30 ph-30">
      <div class="box mt-20">
        <div class="box-header">
          <h3>{{boardTitle}}</h3>
          <p>{{boardTitle}}을(를) 작성합니다.</p>
        </div>
        <div class="box-body" style="over-folow">
          <form action="">
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">작성자</span>
              </label>
              <div class="col-8 pt-2">
                <input type="text"  v-model="item.createUser" class="form-control form-control-success" :disabled="!isNew">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">제목</span>
              </label>
              <div class="col-8 pt-2">
                <input type="text" v-model="item.title"  class="form-control form-control-success">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="ess">내용</span>
              </label>
              <div class="col-8 pt-2">
                <vue-editor v-model="item.content" :editorToolbar="customToolbar"/>
              </div>
            </div>

             <div class="form-group row" v-if="getFileSize()">
                <label class="col-2 form-control-label">
                  <span class="ess">첨부된 파일</span>
                </label>
                <div class="col-8 pt-2">
                  <div class="box border-box mb-10" v-for="(file, index) in item.fileList" :key="index">
                    <div class="box-body">
                      <div class="btn btn-m flat pull-right" style="margin:-3px -3px 0 0" @click="deleteFile(file)">
                        <i class="icon-close"></i>
                      </div>
                      <i class="icon-image"></i>
                      <span class="mh-5">{{file.fileName}}</span>
                      <h5 class="d-inline-block">{{file.fileSize}}kb</h5>
                    </div>
                  </div>
                </div>
             </div>
             <div class="form-group row">
                <label class="col-2 form-control-label">
                  <span class="ess">파일 첨부</span>
                </label>
                <div class="col-8 pt-2">
                  <vue2Dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-success="vdropzoneSuccess"></vue2Dropzone>
                </div>
             </div>
          </form>
        </div>
      </div>
      <div class="btn-wrap mt-30 justify-content-center">
        <button class="btn btn-lg line-2" @click="list()">목록</button>
        <button class="btn btn-lg blue" @click="save()" >저장</button>
      </div>
    </div>
  </div>
</template>

<script>
import DataTableBase from '@/components/common/dataTableBase';
import PageHeader from '@/layout/PageHeader.vue';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { VueEditor } from "vue2-editor"

export default {
  mixins: [DataTableBase],
  components: { PageHeader, vue2Dropzone, VueEditor},
  props: ['boardTitle', 'boardName'],
  data(){
    return {
      content: "",
      fileList: [],
      oEditors: null,
      getApi: 'board',
      saveApi: 'board',
      data: {title: '공지사항', userName: '강선호', content: '동해물과 백두신이 마르고'},
      dropzoneOptions: {
          url: '/api/private/board/fileUpload',
          thumbnailWidth: 150,
          maxFilesize: 20,
          headers: { "My-Awesome-Header": "header value" }
      },
      customToolbar: [
        [{ font: [] }],

        // [{ header: [false, 1, 2, 3, 4, 5, 6] }],

        [{ size: ["small", false, "large", "huge"] }],

        ["bold", "italic", "underline", "strike"],

        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],

        [{ header: 1 }, { header: 2 }],

        ["blockquote", "code-block"],

        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

        // [{ script: "sub" }, { script: "super" }],

        [{ indent: "-1" }, { indent: "+1" }],

        [{ color: [] }, { background: [] }],

        // ["link", "image", "video", "formula"],
        ["link", "image"],

        // [{ direction: "rtl" }],
        // ["clean"]
      ]
    }
  },
  computed: {
    getBoardDesc(){
      return this.boardTitle + ' 내용입니다.';
    },
    isNew(){
      return this.$route.params.id == "new" ? true : false;
    }
  },
  mounted(){
    this.init();
  },
  methods: {
    vdropzoneSuccess(file, xhr, formData){

      xhr.id
      var o = {fileIndex: xhr.id, boardIndex: null}
      this.fileList.push(o);
    },
    init(){
      var that = this;
      this.uploadFiles = [];
      setTimeout(()=>{
        if(this.$route.query.mode == "edit")
          that.getItemById(that.$route.params.id);
      })
    },
    /*
    updateItem(){
      this.save(this.item);
    },
    */
    save(){
      var id = this.$route.params.id;
      this.item.fileList = this.fileList;
      this.item.boardName = this.boardName;

      this.$http.post('/api/private/' + this.saveApi + '/' + id, this.item)
        .then(function(result){
          // this.$toast.success('저장되었습니다.');
          this.noti('완료', '저장되었습니다.', 'success');
          this.init();
          this.selectedIndex = null;
        }.bind(this)).catch((e) =>{
          console.log(e);
      })
    },
    deleteFile(item){

      var that = this;

      this.$http.post('/api/private/extFile/'+ item.fileIndex, item)
        .then((result) => {


          _.remove(that.item.fileList, {
              fileIndex: result.data.payload.fileIndex
          });
          that.$forceUpdate();
        }).catch((e) =>{
          console.log(e);
      })

    },
    getFileSize(){

      if(this.item.fileList){

        return this.item.fileList.length > 0 ? true : false;

      }else{
        return false;
      }
    },
    list(){
      var query = Object.assign({},this.$route.query);
      query.mode = 'list';
      this.$router.push({ path: '/app/' + this.boardName + '/', query: query})
    }
  }
}
</script>

<style>

</style>
